import React from 'react';
import {View, Pressable, Share, Platform} from 'react-native';
import moment from 'moment';
import {UNFAV_A_RESOURCE, HTTP_METHODS} from '../../../utils/URLConstants';

import Text from '../../elements/Text';
import CachedImage from '../../elements/CachedImage';

import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../../theme';
import {DLog} from '../../../utils/HelperMethods';
import {fetchApi} from '../../../utils/ApiHelper';
import Divider from '../../elements/Divider';
import {RWebShare} from '../../../utils/mockedWebLibs/react-web-share';
import {tID} from '../../../utils/TestIdHelper';
import {trackEvent} from '../../../utils/Analytics';
import {HeartFilledIcon, LinkIcon} from '../../../utils/SvgIcons';
import CommonStyles from '../../../utils/CommonStyles';

const FavoriteResourceCard = ({item, refreshMainList}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  const unFavouriteAResource = () => {
    DLog('unFav resource from', item);
    fetchApi(HTTP_METHODS.DELETE, UNFAV_A_RESOURCE(item.id))
      .then(res => {
        DLog('result is', res.data);
        refreshMainList();
      })
      .catch(e => DLog('error is', e));
  };

  const shareTrackEvent = () => {
    trackEvent('Share Resource', {resourceid: item.id});
  };

  const onShare = async () => {
    try {
      shareTrackEvent();
      let content = {};
      let options = {};
      if (Platform.OS == 'ios') {
        content = {
          title: 'Share Article',
          url: item.url,
        };
      } else {
        content = {
          title: 'Share Article',
          message: item.url,
        };
        options = {
          dialogTitle: 'Share Article',
        };
      }
      const result = await Share.share(content, options);
      if (result.action === Share.sharedAction) {
        if (result.activityType) {
          // shared with activity type of result.activityType
        } else {
          // shared
        }
      } else if (result.action === Share.dismissedAction) {
        // dismissed
      }
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <View
      testID={tID('FavoriteResourceCard-View-Main')}
      style={styles.container}>
      <View style={styles.topRow}>
        <CachedImage source={item.heroImage} style={styles.image} />
        <View style={styles.content}>
          <Text
            testID={tID('FavoriteResourceCard-Text-Title')}
            numberOfLines={2}
            variation="Body1SemiBold"
            color={colors.textPrimary}>
            {item.title}
          </Text>
          <Text
            testID={tID('FavoriteResourceCard-Text-AuthorName')}
            variation="Text2Medium"
            color={colors.textMuted}
            topMargin={14}>
            {item.articleAuthorLink.length > 0
              ? item.articleAuthorLink[0].articleAuthor.name
              : ''}
          </Text>
        </View>
      </View>
      <Divider color={colors.border} />
      <View style={styles.bottomRow}>
        <Text
          testID={tID('FavoriteResourceCard-Text-Published')}
          variation="Text2Medium"
          color={colors.textMuted}>
          {moment(item.published).fromNow()}
        </Text>
        <View style={styles.topRow}>
          <Pressable
            testID={tID('FavoriteResourceCard-Pressable-Heart')}
            onPress={unFavouriteAResource}>
            <HeartFilledIcon
              testID={tID('FavoriteResourceCard-Image-Heart')}
              width={Platform.OS === 'web' ? 20 : 18}
              height={Platform.OS === 'web' ? 20 : 15}
              style={CommonStyles.mr_16}
            />
          </Pressable>
          {Platform.OS === 'web' ? (
            <Pressable
              testID={tID('FavoriteResourceCard-Pressable-Share')}
              onPress={shareTrackEvent}>
              <RWebShare
                data={{
                  url: item.url,
                  title: 'Share Article',
                }}
                onClick={() => console.log('shared successfully!')}>
                <LinkIcon
                  testID={tID('FavoriteResourceCard-Image-Share')}
                  width={20}
                  height={20}
                />
              </RWebShare>
            </Pressable>
          ) : (
            <Pressable
              testID={tID('FavoriteResourceCard-Pressable-Share')}
              onPress={onShare}>
              <LinkIcon testID={tID('FavoriteResourceCard-Image-Share')} />
            </Pressable>
          )}
        </View>
      </View>
    </View>
  );
};

export default FavoriteResourceCard;
